import createDebug from 'debug';

const GOOGLE_ANALYTICS = 'UA-5784146-31';

const debug = createDebug('lib:tracking');

const isDev = env => env !== 'production';

export const initializeTracking = () => {
  if (isDev(process.env.NODE_ENV)) return;

  // Google Tag Manager

  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      /* istanbul ignore next */
      dl = l != 'dataLayer' ? '&l=' + l : '';
    //@ts-ignore
    j.async = true;
    //@ts-ignore
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    //@ts-ignore
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-NFX358T');

  // Google Analytics
  /* eslint-disable */
  (function(i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    (i[r] =
      i[r] ||
      function() {
        (i[r].q = i[r].q || []).push(arguments);
      }),
      //@ts-ignore
      (i[r].l = 1 * new Date());
    //@ts-ignore
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    //@ts-ignore
    a.async = 1;
    //@ts-ignore
    a.src = g;
    //@ts-ignore
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
  //@ts-ignore
  ga('create', GOOGLE_ANALYTICS, 'auto');
  //@ts-ignore
  ga('set', 'anonymizeIp', true);
  //@ts-ignore
  ga('require', 'displayfeatures');
  /* eslint-enable */
};

export const trackPageview = (path: string = window.location.pathname): void => {
  debug('send:pageview', path);

  if (window.ga) {
    window.ga('send', 'pageview', path);
  }
};

interface Event {
  action: string;
  category?: string;
  label?: string;
  value?: number;
  nonInteraction?: boolean;
  page?: string;
}

export const trackEvent = ({
  category = 'Event',
  action,
  value = 0,
  label,
  nonInteraction = false,
  page = window.location.pathname,
}: Event): void => {
  const payload = {
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    eventValue: value,
    nonInteraction,
    page,
  };

  debug('send:event', payload);

  if (window.ga) {
    window.ga('send', 'event', payload);
  }
};
